export default "__VITE_ASSET__YWnI_nne__"